import { type OpenApiSchemaErrorCode } from '../../../api/schema';

export function isRequestError(
    error: unknown
): error is { responseData: { message: string; code: OpenApiSchemaErrorCode } } {
    return Boolean(
        error instanceof Error &&
            'responseData' in error &&
            error.responseData &&
            typeof error.responseData === 'object' &&
            'message' in error.responseData &&
            typeof error.responseData.message === 'string' &&
            'code' in error.responseData &&
            typeof error.responseData.code === 'string'
    );
}
